import React from 'react';
import { Route, Link } from 'react-router-dom';

import './MenuLink.css';

const MenuLink = ({ path, icon, children, className }) => {
  return (
    <Route
      path={path}
      children={({ match }) => (
        <Link className={`Menu-link${match ? ' active' : ''}${className ? ` ${className}` : ''}`} to={path}>
          {icon && <div className="Menu-link-icon">{icon}</div>}
          <div className="Menu-link-children">
            {children}
          </div>
        </Link>
      )}
    />
  );
};

export default MenuLink;



// WEBPACK FOOTER //
// ./src/components/basic/MenuLink.js